import { ReadonlySignal } from '@preact/signals-react';

import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';
import { ProfileLiveMediaModel } from '@vp/profile/core/model/ProfileLiveMediaModel';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';
import { ProfilePhotoModel } from '@vp/profile/core/model/ProfilePhotoModel';

export type ProfileManagerStatus = 'initial' | 'loading' | 'loaded' | 'error';

export abstract class ProfileManagerState {
  abstract readonly active: ReadonlySignal<ProfileModel | null>;
  abstract readonly profiles: ReadonlySignal<ProfileModel[]>;
  abstract readonly status: ReadonlySignal<ProfileManagerStatus>;

  abstract loading(): void;
  abstract completed(status: ProfileManagerStatus, profiles?: ProfileModel[]): void;
  abstract getById(id: string): ProfileModel | null;
  abstract setActive(profile: ProfileModel): void;
  abstract update(profile: ProfileModel): void;
  abstract reset(): void;
  abstract updateAccess(access: ProfileAccessModel): void;
  abstract getPhotoOfActiveProfileBy(id: string): ProfilePhotoModel;
  abstract updatePhoto(photo: ProfilePhotoModel): void;
  abstract updateLiveMedia(liveMedia: ProfileLiveMediaModel): void;
  abstract hasPhotoAnimationAttempts(): boolean;
  abstract hasProfileImageAnimationAttempts(): boolean;
}
